import { AiFillInstagram } from 'react-icons/ai';
import { FaFacebookF, FaTwitter } from 'react-icons/fa';

import BlogImage from '../../assets/img/blog/02.jpg';
import Avatar01 from '../../assets/img/avatar/01.jpg';
import Avatar02 from '../../assets/img/avatar/02.jpg';

import Footer from '../../components/footer';
import Navbar from '../../components/navbar';

import { Link } from 'react-router-dom';


const BlogDetails = () =>{
    return(
      <>
      <header
      className="container-fluid bg-primary headerExtra"
      id="home">
        <div className="container h-100 ">
          <Navbar />
          <div className="d-flex flex-column align-items-center justify-content-center h-75 text-white">
            <h1 className="text-white display-4">
              Blog details
            </h1>
            <div>
            <Link
            className="text-white mx-2"
            to="/home01">
              Home
            </Link>
              &#11166;
            <Link
            className="text-white mx-2"
            to="/blog01">
              Blog Grid
            </Link>
              &#11166;
            <Link
            className="text-white mx-2"
            to="/blog/details">
              Blog Details
            </Link>
          </div>
          </div>
        </div>
      </header>
      <div className="container mt-5">
        <div className="col-12 d-flex">
          <img
          src={BlogImage}
          alt="..."
          className="img-fluid rounded-lg"
          />
        </div>
        <div className="col-12 d-flex justify-content-between mt-3">
          <div className="d-flex">
            <p className="mx-1  mx-md-2">
              by <a href="...">Rafaela dias</a>
            </p>
            |
            <p className="mx-1 mx-md-2">
              07/oct/2021
            </p>
            |
            <p class="mx-1 mx-md-2">
              4 coments
            </p>
          </div>
          <div className="d-none d-md-flex text-white">
            <Link
            className="p-1 bg-instagram rounded d-flex justify-content-center align-items-center text-white"
            style={{width: '36px', height: '36px'}}>
              <AiFillInstagram
              size={24}
              />
            </Link>
            <Link
            className="p-1 bg-facebook rounded d-flex justify-content-center align-items-center mx-2 text-white"
            style={{width: '36px', height: '36px'}}>
              <FaFacebookF
              size={24}
              />
            </Link>
            <Link
            className="p-1 bg-twitter rounded d-flex justify-content-center align-items-center text-white"
            style={{width: '36px', height: '36px'}}>
              <FaTwitter
              size={24}
              />
            </Link>
          </div>
        </div>
        <div className="col-12">
          <h2 className="hover-primary font-weight-bold">12 ways to improve teamwork</h2>
          <p className="paragraph">
          Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum
          has been the industry's standard dummy text ever since the 1500s, when an unknown printer
          took a galley of type and scrambled it to make a type specimen book. It has survived not only
          five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.
          It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum
          passages, and more recently with desktop publishing software like Aldus PageMaker including
          versions of Lorem Ipsum. Lorem Ipsum is simply dummy text of the printing and typesetting industry.
          Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown
          printer took a galley of type and scrambled it to make a type specimen book. It has survived not
          only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.
          It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages,
          and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum
          </p>
          <p className="mt-2 paragraph">
          Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum
          has been the industry's standard dummy text ever since the 1500s, when an unknown printer
          took a galley of type and scrambled it to make a type specimen book. It has survived not only
          five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.
          It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum
          passages, and more recently with desktop publishing software like Aldus PageMaker including
          versions of Lorem Ipsum. Lorem Ipsum is simply dummy text of the printing and typesetting industry.
          Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown
          printer took a galley of type and scrambled it to make a type specimen book. It has survived not
          only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.
          It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages,
          and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum
          </p>
          <div className="border-top division2 pt-5 d-flex align-items-start align-items-md-center">
            <div className="avatar mr-4">
              <img
              src={Avatar01}
              alt=""
              className="img-fluid rounded-circle"
              />
            </div>
            <div className="col-7 col-md-9 col-lg-10">
              <h2 className="font-weight-bold">
                julian alvez
              </h2>
              <p className="paragraph">
                Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum
                has been the industry's standard dummy text ever since
              </p>
            </div>
          </div>
          <div className="d-flex flex-column align-items-end">
            <div className="col-12 col-md-10 col-lg-8 col-xl-7 division">
              <h1 className="text-right font-weight-bold">
                Recent Coments
              </h1>
                <div className="mt-5">
                  <div className="border p-4 d-flex align-items-start align-items-md-center">
                    <div className="avatar mr-4">
                      <img
                      src={Avatar02}
                      alt=""
                      className="img-fluid rounded-circle"
                      />
                    </div>
                    <div className="col-6 col-md-8 col-lg-9">
                      <h2>William Dent</h2>
                      <p className="paragraph">
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum
                        has been the industry's standard dummy text ever since
                      </p>
                    </div>
                  </div>
                  <div className="border p-4 mt-3 d-flex align-items-start align-items-md-center">
                    <div className="avatar mr-4">
                      <img
                      src={Avatar02}
                      alt=""
                      className="img-fluid rounded-circle"
                      />
                    </div>
                    <div className="col-6 col-md-8 col-lg-9 col-6">
                      <h2>William Dent</h2>
                      <p className="paragraph">
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum
                        has been the industry's standard dummy text ever since
                      </p>
                    </div>
                  </div>
                </div>
            </div>
            <div className="col-12 col-md-10 col-lg-8 col-xl-7 division2">
              <h1 className="text-right font-weight-bold">
                New Coment
              </h1>
              <form
              action=""
              className="mt-5">
                <div className="row">
                  <input
                  type="text"
                  placeholder="name"
                  className="form-control form-control-lg"
                  />
                </div>
                <div className="row">
                  <input
                  type="text"
                  placeholder="email"
                  className="form-control form-control-lg my-3"
                  />
                </div>
                <div className="row">
                  <textarea
                  type="text"
                  placeholder="coment"
                  className="form-control form-control-lg"
                  />
                </div>
                <div className="row">
                  <button className="btn btn-primary btn-lg mt-3 btn-block">
                    send
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      </>
    )
  };
export default BlogDetails;